import { y, x, width, height } from './accessors.js';
import { getBarStyle } from './bar-style.js';
import { useDisplayConfigContext } from './DisplayConfigContext.js';
import { BarCanvas } from '../../../core/components/canvas/components/BarCanvas.js';
import { useGridPlotSize } from '../../../core/components/chart-grid/hooks/useGridPlotSize.js';
import { useHistogramFilteredData } from '../../hooks/useHistogramFilteredData.js';
import { useHistogramYScales } from '../../hooks/useHistogramYScales.js';
import { safeGet } from '../../providers/HistogramDataProvider.js';
import { XScale } from '../../types/histogram.js';

interface BarChartDisplayProps {
  xScale: XScale;
}

export function BarChartDisplay({ xScale }: BarChartDisplayProps) {
  const yScales = useHistogramYScales();
  const { width: widthPlot, height: heightPlot } = useGridPlotSize();
  const { series, seriesMap, binsMap } = useHistogramFilteredData();

  const { highlightedSeriesIds } = useDisplayConfigContext();

  return (
    <div data-testid="histogram-bar-chart-display">
      {series.map((singleSeries) => {
        const seriesMetadata = safeGet(seriesMap, singleSeries);

        const yScale = yScales[seriesMetadata.scaleIndex];

        const { color, opacity } = getBarStyle(
          seriesMetadata,
          highlightedSeriesIds,
        );

        return (
          <BarCanvas
            key={seriesMetadata.id}
            data={singleSeries.bins}
            canvasWidth={widthPlot}
            canvasHeight={heightPlot}
            x={x(xScale, binsMap)}
            y={y(yScale, binsMap)}
            width={width(xScale, binsMap)}
            height={height(yScale, binsMap)}
            strokeWidth={1}
            color={() => color}
            opacity={() => opacity}
          />
        );
      })}
    </div>
  );
}
